document.addEventListener("DOMContentLoaded", () => {
  const navSwiper = () => {
    new Swiper(".nav-swiper", {
      slidesPerView: "auto",
      watchOverflow: true,
      freeMode: true,
      mousewheel: {
        enabled: true,
        releaseOnEdges: true,
        forceToAxis: true,
      },
    });
  };

  document.addEventListener("shopify:section:load", () => {
    navSwiper();
  });

  navSwiper();
});

document.addEventListener("DOMContentLoaded", function () {
  document.addEventListener("click", function (event) {
    if (event.target.classList.contains("filter-item")) {
      document.querySelectorAll(".build-nav__item").forEach((navItem) => {
        navItem.classList.remove("active");
      });
    }

    if (
      !targetElement.contains(event.target) ||
      event.target.classList.contains("filter-item")
    ) {
      targetElement.classList.remove("active");
    }
  });

  const stickyElement = document.querySelector(".collection-nav");
  const initialTopPosition = stickyElement.offsetTop;
  let isSticky = false;
  let isAddingClass = false;
  let isRemovingClass = false;

  function handleScroll() {
    const shouldAddClass = window.scrollY >= initialTopPosition;

    if (shouldAddClass && !isSticky && !isAddingClass) {
      isAddingClass = true;
      isRemovingClass = false;
      stickyElement.classList.add("nav-is-sticky");
      isSticky = true;
      isAddingClass = false;
    } else if (!shouldAddClass && isSticky && !isRemovingClass) {
      isRemovingClass = true;
      isAddingClass = false;
      stickyElement.classList.remove("nav-is-sticky");
      isSticky = false;
      isRemovingClass = false;
    }
  }

  window.addEventListener("scroll", handleScroll);

  const targetElement = document.querySelector(".select-anchor");

  targetElement.addEventListener("click", function (event) {
    targetElement.classList.toggle("active");
  });

  document.addEventListener("click", function (event) {
    if (
      !targetElement.contains(event.target) ||
      event.target.classList.contains("filter-item")
    ) {
      targetElement.classList.remove("active");
    }
  });

  document.querySelectorAll(".build-nav__item").forEach((element) => {
    element.addEventListener("click", function () {
      const anchorId = this.dataset.target;
      if (anchorId) {
        const anchorElement = document.getElementById(anchorId);
        if (anchorElement) {
          anchorElement.scrollIntoView({ behavior: "smooth" });
        }
      }
    });
  });

  const navItems = document.querySelectorAll(".build-nav__item");

  function setActiveNavItem() {
    navItems.forEach((navItem) => {
      const anchorId = navItem.dataset.target;
      const section = document.getElementById(anchorId);

      if (section) {
        const rect = section.getBoundingClientRect();

        if (
          rect.top <= window.innerHeight / 2 &&
          rect.bottom >= window.innerHeight / 2
        ) {
          navItems.forEach((item) => {
            item.classList.remove("active");
          });

          navItem.classList.add("active");
        }
      }
    });
  }

  window.addEventListener("scroll", setActiveNavItem);

  setActiveNavItem();
});
